import React from 'react';
import {Col, ListGroup, ListGroupItem, Row} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import taxonomyService from '../main/taxonomyService';
import {FormattedMessage} from 'react-intl';
import {injectIntl} from 'react-intl';
import i18n from "../main/i18n";

export default injectIntl(props => {

  const msg = i18n.getMsg(props.intl);
  const serviceAreaTitle = msg(`customer.${process.env.REACT_APP_CUSTOMER}.serviceAreaTitle`);
  const serviceAreas = taxonomyService.getAllServiceAreas().map(serviceArea => {

    const allEvidenceTypes = taxonomyService.getAllEvidenceTypes(serviceArea);
    let singleEvidenceTypeId = null;

    const evidenceCategories = Object.keys(allEvidenceTypes);

    if (evidenceCategories.length === 1) {
      const singleCategoryName = evidenceCategories[0];
      const singleCategory = allEvidenceTypes[singleCategoryName];

      if (singleCategory.length === 1 && !singleCategory[0].verificationRequired) {
        singleEvidenceTypeId = singleCategory[0].id
      }
    }

    // skip the evidence type chooser if there's only one evidence type
    if (singleEvidenceTypeId) {
      return (
        <LinkContainer to={`/${serviceArea.id}/${singleEvidenceTypeId}`} key={serviceArea.id}>
          <ListGroupItem>{serviceArea.label}</ListGroupItem>
        </LinkContainer>
      )
    } else {
      return (
        <LinkContainer to={serviceArea.id} key={serviceArea.id}>
          <ListGroupItem>{serviceArea.label}</ListGroupItem>
        </LinkContainer>
      );
    }
  });

  return (
    <Row>
      <Col md={6}>
        <h4>
          <FormattedMessage id="chooseServiceArea" defaultMessage="{serviceTitle}" values={{serviceTitle: serviceAreaTitle}}/>
        </h4>
        <ListGroup>{serviceAreas}</ListGroup>
      </Col>
    </Row>
  );
});
